import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { TextLink as CoreTextLink } from '@vds-core/buttons';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { colors } from '@vds/theme';
var propTypes = {
  size: PropTypes.oneOf(['large', 'small'])
};

var TextLink = function TextLink(props) {
  var size = props.size;
  return /*#__PURE__*/React.createElement(CoreTextLink, _extends({}, props, {
    focusState: true,
    hitArea: true,
    typescale: TypographyConfig.getTypescale(),
    size: size,
    colorConfig: colors,
    bodyConfig: BodyConfig,
    activeState: false
  }));
};

TextLink.propTypes = propTypes;
export default TextLink;